import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_BehaviorAndSymptomRatingScale = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_BehaviorAndSymptomRatingScale' className='file-pdf-document'>
            <div className='file-template'>


                <h3><center><u>Behavior and Symptom Rating Scale</u></center></h3>

                <p className='w-750'>
                    <span className='eleHeader'>What is the client's presenting problem/why are they here?</span>
                    <span className='small'>(This should be in the client's own words.)</span>
                    <textarea id="txtclientsPresentingProblem" name="txtclientsPresentingProblem" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is the parent's/family's perception of the problem?</span>
                    <span className='small'>This should be in the parent's/family's own words.)</span>
                    <textarea id="txtParentsfamilyPerceptionProblem" name="txtParentsfamilyPerceptionProblem" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe precipitating events:</span>
                    <span className='small'>(Include the onset of the problem, duration, frequency, past intervention/services and the results of the services.)</span>
                    <textarea id="txtPrecipitatingEvents" name="txtPrecipitatingEvents" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>DSM-IV Diagnosis:</span>
                    <span className='small'>(Please make sure it matches with client's assessment and share note diagnosis.)</span>
                    <textarea id="txtDiagnosis" name="txtDiagnosis" className='add-only'></textarea>
                </p>

                <span className='eleHeader'><center>BEHAVIOR AND SYMPTOM RATING SCALE</center></span>
                <p className='w-750'>
                    <strong>Please complete the below checklist for symptoms and behaviors:</strong>

                </p>
                <p className='w-750'>
                    <strong> Key Severity Rating:</strong> 0=None ,1=Mild ,2=Moderate ,3=Severe

                </p>
                <p className='w-750'>
                    <strong> Frequency Rating: </strong>  Note the number of times the behavior occurs (i.e. 2x daily, 3-4x weekly, 5-7x monthly, 1x lifetime, etc.)

                </p>

                <table>
                    <tr>
                        <td className='w-300'><span><strong>Symptom/Problem</strong></span></td>
                        <td className='w-150'><span><strong>Severity</strong></span></td>
                        <td className='w-150'><span><strong>Frequency</strong></span></td>
                        <td className='w-150'><span><strong>As Evidenced By (within the last 90 days; be specific)</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>1 Anxiety</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_1" name="ddlSeverity_1" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_1" name="txtFrequency_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_1" name="txtEvidenced_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>2 Phobias</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_2" name="ddlSeverity_2" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_2" name="txtFrequency_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_2" name="txtEvidenced_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>3 Panic Attacks</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_3" name="ddlSeverity_3" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_3" name="txtFrequency_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_3" name="txtEvidenced_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>4 Obsessive/Compulsive</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_4" name="ddlSeverity_4" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_4" name="txtFrequency_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_4" name="txtEvidenced_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>5 Appetite Problems</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_5" name="ddlSeverity_5" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_5" name="txtFrequency_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_5" name="txtEvidenced_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>6 Loss of Energy</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_6" name="ddlSeverity_6" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_6" name="txtFrequency_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_6" name="txtEvidenced_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>7 Loss of Interest</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_7" name="ddlSeverity_7" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_7" name="txtFrequency_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_7" name="txtEvidenced_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>8 Low Self-Esteem</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_8" name="ddlSeverity_8" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_8" name="txtFrequency_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_8" name="txtEvidenced_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>9 Depressed Mood</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_9" name="ddlSeverity_9" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_9" name="txtFrequency_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_9" name="txtEvidenced_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>10 Aggressive</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_10" name="ddlSeverity_10" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_10" name="txtFrequency_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_10" name="txtEvidenced_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>11 Frustrated Easily</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_11" name="ddlSeverity_11" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_11" name="txtFrequency_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_11" name="txtEvidenced_11" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>12 Irritable</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_12" name="ddlSeverity_12" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_12" name="txtFrequency_12" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_12" name="txtEvidenced_12" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>13 Verbal/Physical Altercations</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_13" name="ddlSeverity_13" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_13" name="txtFrequency_13" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_13" name="txtEvidenced_13" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>14 Moody</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_14" name="ddlSeverity_14" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_14" name="txtFrequency_14" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_14" name="txtEvidenced_14" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>15 Conduct Problems</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_15" name="ddlSeverity_15" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_15" name="txtFrequency_15" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_15" name="txtEvidenced_15" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>16 Oppositional/Defiant</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_16" name="ddlSeverity_16" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_16" name="txtFrequency_16" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_16" name="txtEvidenced_16" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>17 Lies Frequently</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_17" name="ddlSeverity_17" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_17" name="txtFrequency_17" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_17" name="txtEvidenced_17" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>18 Fire Setting</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_18" name="ddlSeverity_18" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_18" name="txtFrequency_18" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_18" name="txtEvidenced_18" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>19 Cruelty to Animals</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_19" name="ddlSeverity_19" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_19" name="txtFrequency_19" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_19" name="txtEvidenced_19" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>20 Running Away</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_20" name="ddlSeverity_20" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_20" name="txtFrequency_20" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_20" name="txtEvidenced_20" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>21 Bullies/Threatens</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_21" name="ddlSeverity_21" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_21" name="txtFrequency_21" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_21" name="txtEvidenced_21" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>22 Stealing</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_22" name="ddlSeverity_22" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_22" name="txtFrequency_22" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_22" name="txtEvidenced_22" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>23 Eating Disorder</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_23" name="ddlSeverity_23" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_23" name="txtFrequency_23" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_23" name="txtEvidenced_23" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>24 Family Problems</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_24" name="ddlSeverity_24" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_24" name="txtFrequency_24" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_24" name="txtEvidenced_24" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>25 Gender Issues</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_25" name="ddlSeverity_25" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_25" name="txtFrequency_25" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_25" name="txtEvidenced_25" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>26 Impaired Memory</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_26" name="ddlSeverity_26" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_26" name="txtFrequency_26" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_26" name="txtEvidenced_26" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>27 Unresolved Grief</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_27" name="ddlSeverity_27" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_27" name="txtFrequency_27" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_27" name="txtEvidenced_27" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>28 Gambling</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_28" name="ddlSeverity_28" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_28" name="txtFrequency_28" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_28" name="txtEvidenced_28" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>29 Short Attention Span</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_29" name="ddlSeverity_29" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_29" name="txtFrequency_29" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_29" name="txtEvidenced_29" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>30 Hyperactivity</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_30" name="ddlSeverity_30" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_30" name="txtFrequency_30" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_30" name="txtEvidenced_30" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>31 Impulsive</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_31" name="ddlSeverity_31" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_31" name="txtFrequency_31" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_31" name="txtEvidenced_31" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>32 Incoherent Speech</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_32" name="ddlSeverity_32" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_32" name="txtFrequency_32" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_32" name="txtEvidenced_32" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>33 Paranoid Ideation</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_33" name="ddlSeverity_33" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_33" name="txtFrequency_33" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_33" name="txtEvidenced_33" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>34 Bizarre Ideations (Delusions)</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_34" name="ddlSeverity_34" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_34" name="txtFrequency_34" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_34" name="txtEvidenced_34" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>35 Bizarre Behavior</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_35" name="ddlSeverity_35" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_35" name="txtFrequency_35" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_35" name="txtEvidenced_35" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>36 Hallucinations</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_36" name="ddlSeverity_36" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_36" name="txtFrequency_36" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_36" name="txtEvidenced_36" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>37 Poor Self Care Skills</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_37" name="ddlSeverity_37" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_37" name="txtFrequency_37" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_37" name="txtEvidenced_37" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>38 Self-Injurious Behaviors</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_38" name="ddlSeverity_38" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_38" name="txtFrequency_38" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_38" name="txtEvidenced_38" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>39 Head Banging</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_39" name="ddlSeverity_39" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_39" name="txtFrequency_39" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_39" name="txtEvidenced_39" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>40 Poor Interpersonal Skills</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_40" name="ddlSeverity_40" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_40" name="txtFrequency_40" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_40" name="txtEvidenced_40" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>41 Poor Judgment</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_41" name="ddlSeverity_41" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_41" name="txtFrequency_41" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_41" name="txtEvidenced_41" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>42 Bedwetting</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_42" name="ddlSeverity_42" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_42" name="txtFrequency_42" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_42" name="txtEvidenced_42" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>43 Sleep Problems</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_43" name="ddlSeverity_43" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_43" name="txtFrequency_43" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_43" name="txtEvidenced_43" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>44 Disruptive</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_44" name="ddlSeverity_44" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_44" name="txtFrequency_44" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_44" name="txtEvidenced_44" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>45 School Problems</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_45" name="ddlSeverity_45" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_45" name="txtFrequency_45" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_45" name="txtEvidenced_45" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>46 Truancy</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_46" name="ddlSeverity_46" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_46" name="txtFrequency_46" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_46" name="txtEvidenced_46" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>47 Learning Problems</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_47" name="ddlSeverity_47" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_47" name="txtFrequency_47" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_47" name="txtEvidenced_47" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>48 Sexual Acting Out</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_48" name="ddlSeverity_48" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_48" name="txtFrequency_48" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_48" name="txtEvidenced_48" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>49 Posttraumatic Stress Disorder </span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_49" name="ddlSeverity_49" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_49" name="txtFrequency_49" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_49" name="txtEvidenced_49" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>50 Independent. Living Problems</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_50" name="ddlSeverity_50" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_50" name="txtFrequency_50" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_50" name="txtEvidenced_50" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>51 Lack of Support System</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_51" name="ddlSeverity_51" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_51" name="txtFrequency_51" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_51" name="txtEvidenced_51" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>52 Gang Involvement</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_52" name="ddlSeverity_52" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_52" name="txtFrequency_52" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_52" name="txtEvidenced_52" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>53 Somatization</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_53" name="ddlSeverity_53" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_53" name="txtFrequency_53" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_53" name="txtEvidenced_53" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><span>54 Unusual Body Movements</span></td>
                        <td className='w-150'>
                            <select id="ddlSeverity_54" name="ddlSeverity_54" className='add-only'>
                                <option value=""></option>
                                <option value="0=none">0=None</option>
                                <option value="1=mild">1=Mild</option>
                                <option value="2=moderate">2=Moderate</option>
                                <option value="3=severe">3=Severe</option>
                            </select>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_54" name="txtFrequency_54" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtEvidenced_54" name="txtEvidenced_54" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><strong>*Please mark only symptoms and behaviors that currently apply to the client, and be specific with information.</strong></p>






            </div>
        </form>

    )
}